import axios from "axios";

// Create an axios instance
const apiClient = axios.create({
  // Set the base URL for all API requests.
  // This will be `https://dafrom-api-dev.enhancers.it` in your EC2 environment
  // and will fall back to the proxy for local development if the variable is not set.
  baseURL: process.env.REACT_APP_API_URL || "/",
});

export default apiClient;
